import {DrawerWrapper} from '@wandb/weave/common/components/DrawerWrapper';
import React from 'react';

import {useRampFlagMediaSettingsDrawerAllTypesUser} from '../../../util/rampFeatureFlags/rampFeatureFlags';
import {useSupportedMediaDrawerTypes} from '../../PanelMediaBrowser/supportedMediaDrawerTypes';
import {useWorkspaceDrawerContext} from '../WorkspaceDrawerContextProvider';
import {
  SECTION_LINE_PLOT_SETTINGS_DESCRIPTION,
  SECTION_MEDIA_SETTINGS_DESCRIPTION,
} from './constants';
import {useSectionMediaCardTypes, useSectionMediaKeys} from './hooks';
import {SettingsMenuItem} from './SettingsMenuItem';

export enum SelectedSectionSettingType {
  LinePlot = 'line-plot',
  Media = 'media',
}

export const SectionSettingsMenu = ({
  setSelectedSettingType,
}: {
  setSelectedSettingType: (type: SelectedSectionSettingType) => void;
}) => {
  const {closeWorkspaceDrawer} = useWorkspaceDrawerContext();
  const mediaKeys = useSectionMediaKeys();
  const mediaCardTypes = useSectionMediaCardTypes();
  const {types: supportedMediaDrawerTypes} = useSupportedMediaDrawerTypes();
  const isAllTypesEnabled =
    useRampFlagMediaSettingsDrawerAllTypesUser() === true;
  // Every type has drawer settings with the gate on, so skip the sampled type
  // lookup, which can miss a key.
  const hasSupportedMediaCardType = isAllTypesEnabled
    ? mediaKeys.length > 0
    : mediaCardTypes.some(mediaCardType =>
        supportedMediaDrawerTypes.includes(mediaCardType)
      );
  return (
    <DrawerWrapper title="Section settings" onClose={closeWorkspaceDrawer}>
      <SettingsMenuItem
        dataTest="section-settings-line-plot-menu-item"
        icon="line-plot-alt2"
        color="blue"
        title="Line plots"
        description={SECTION_LINE_PLOT_SETTINGS_DESCRIPTION}
        onClick={() =>
          setSelectedSettingType(SelectedSectionSettingType.LinePlot)
        }
      />
      {hasSupportedMediaCardType && (
        <SettingsMenuItem
          dataTest="section-settings-media-menu-item"
          icon="photo"
          color="purple"
          title="Media"
          description={SECTION_MEDIA_SETTINGS_DESCRIPTION}
          onClick={() =>
            setSelectedSettingType(SelectedSectionSettingType.Media)
          }
        />
      )}
    </DrawerWrapper>
  );
};
